import React, { memo, useEffect, useMemo } from 'react';

import { Box, Typography } from '@mui/material';
import FormGenerator from '@sharedCR/common/formGenerator';
import { FormNames } from 'app/services/autoLockForms/autoLockForms.constants';
import _ from 'lodash';

import { defaultForm, pagesPropTypes } from '../MainContent.constants';
import { boxStyle } from '../MainContent.styles';

import {
  checkIsChattelCommunityPark,
  checkIsChattelLandownerPlacement,
  checkIsChattelLeasedPrivateProperty,
  getChattelPropertyConfig,
} from './ChattelProperty.config';
import { CHATTEL_SUBJECT_PROPERTY_TYPE_LABEL } from './ChattelProperty.constants';
import {
  subjectPropertyTypeLabelStyles,
  subjectPropertyTypeWrapperStyles,
} from './ChattelProperty.styles';

const ChattelProperty = ({
  isLoading,
  isSaving,
  form = defaultForm,
  validationErrors,
  validateField,
  handleChange,
  setEntityConfig,
  setInForm,
  className,
  applicationData,
  staticValidateField,
  pendingChanges,
  disabledPendingChangesHighlight,
}) => {
  const isFormDataEmpty = _.isEmpty(form);
  const entityData = isFormDataEmpty ? applicationData : form;
  const sitePlacementValue = entityData?.sitePlacement?.value ?? entityData?.sitePlacement;

  const isLeasedPrivateProperty = checkIsChattelLeasedPrivateProperty(sitePlacementValue);
  const isCommunityPark = checkIsChattelCommunityPark(sitePlacementValue);
  const isLandownerPlacement = checkIsChattelLandownerPlacement(sitePlacementValue);

  const config = useMemo(
    () =>
      getChattelPropertyConfig({ isLeasedPrivateProperty, isCommunityPark, isLandownerPlacement }),
    [isLeasedPrivateProperty, isCommunityPark, isLandownerPlacement],
  );

  useEffect(() => {
    setEntityConfig(config);
  }, [setEntityConfig, config]);

  return (
    <Box className={className}>
      <Box sx={subjectPropertyTypeWrapperStyles}>
        <Typography sx={subjectPropertyTypeLabelStyles} variant="regular14">
          Subject Property Type
        </Typography>
        <Typography variant="medium14">{CHATTEL_SUBJECT_PROPERTY_TYPE_LABEL}</Typography>
      </Box>

      <Box sx={boxStyle}>
        <FormGenerator
          isNestedForm
          config={config}
          disabledPendingChangesHighlight={disabledPendingChangesHighlight}
          form={form}
          formName={FormNames.CHATTEL_PROPERTY}
          handleChange={handleChange}
          isLoading={isSaving || isLoading}
          numberOfColumns={4}
          pendingChanges={pendingChanges}
          setInForm={setInForm}
          staticValidateField={staticValidateField}
          validateField={validateField}
          validationErrors={validationErrors}
        />
      </Box>
    </Box>
  );
};

ChattelProperty.propTypes = pagesPropTypes;

export default memo(ChattelProperty);
